import { render, staticRenderFns } from "./CmgNutritionCalculatorMealBuilderGroup.vue?vue&type=template&id=7fb2a58f&scoped=true&lang=pug"
import script from "./cmg-nutrition-calculator-meal-builder-group.ts?vue&type=script&lang=ts&external"
export * from "./cmg-nutrition-calculator-meal-builder-group.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgNutritionCalculatorMealBuilderGroup.vue?vue&type=style&index=0&id=7fb2a58f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb2a58f",
  null
  
)

export default component.exports